const TrackingService = {
    
	gtag: {
        
		event ( eventName, eventOpts, role ) {

			// role can be rollup or app

			eventOpts = eventOpts || {};

			role = role || 'default';

			if ( role === 'rollup' && !eventOpts.send_to ) {

				// https://developers.google.com/tag-platform/gtagjs/routing

				eventOpts.send_to = 'G-0KD8CQT3N1';

			}

			if ( typeof gtag !== 'undefined' ) {

				gtag( 'event', eventName, eventOpts );

				console.log( 'gtag event', eventName, eventOpts );

			}
			else if ( typeof window.dataLayer !== 'undefined' ) {

				window.dataLayer.push( {
					'event': eventName,
					...eventOpts
				});

				console.log( 'window.dataLayer event', eventName, eventOpts );

			}
			else {

				console.log( 'gtag/datalayer not defined', eventName, eventOpts );

			}

		}

    }

}

export default TrackingService;